// extracted by mini-css-extract-plugin
export default {"page":"PinCodeSms_page__tbiiJ","content":"PinCodeSms_content__tmAyS","card":"PinCodeSms_card__T2GLf"};